import React from 'react';
import {
  Checkbox,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
} from '@mui/material';

import DeleteIcon from '@mui/icons-material/Delete';
import { useTheme } from '@mui/material';
import { ArtistEmail } from '../../@types/api';

interface Props {
  emails: ArtistEmail[];
  togglePrimary: (value: ArtistEmail) => void;
  deleteEmail: (value: ArtistEmail) => void;
}
const EmailList: React.FC<Props> = ({ emails, togglePrimary, deleteEmail }) => {
  const theme = useTheme();
  return (
    <List
      sx={{
        width: '100%',
        backgroundColor: theme.palette.background.paper,
      }}
    >
      {emails.map((value: ArtistEmail) => {
        const labelId = `checkbox-list-label-${value.emailAddress}`;
        return (
          <ListItem key={value.emailAddress} dense sx={{ p: 0, m: 0 }}>
            <ListItemIcon sx={{ minWidth: '30px' }}>
              <Checkbox
                edge='start'
                checked={value.isPrimary}
                disableRipple
                onClick={() => togglePrimary(value)}
                name='primary'
                size='small'
                sx={{ py: 0 }}
              />
            </ListItemIcon>
            <ListItemText id={labelId} primary={value.emailAddress} />
            <ListItemSecondaryAction onClick={() => deleteEmail(value)}>
              <IconButton edge='end'>
                <DeleteIcon />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
        );
      })}
    </List>
  );
};

export default EmailList;
